import React from 'react';
import { Link } from 'react-router-dom';
import { useContactModal } from '../../components/common/ContactModalContext';
import { Header, Footer } from '../../components/common';
import './Colleges.css';
import './B2C.css';
import collegesHeroImage from '../../images/collage-hero-bg.jpeg';

const PROGRAMS = [
  {
    id: 'sfdc-devops',
    title: 'Master Salesforce DevOps with Copado and Agentia',
    to: '/course/salesforce-devops-copado-agentia?date=22nd%20June%202026&time=8AM-9AM%20IST',
    level: 'Intermediate to Advanced',
    duration: '2 Weeks',
    description:
      'Learn how to accelerate Salesforce releases using Copado and Agentia with CI/CD pipelines and AI-driven release planning.',
  },
  {
    id: 'sfdc-dev',
    title: 'Salesforce AI Developer',
    to: '/course/salesforce-ai-developer?date=1st%20June%202026&time=10AM-12PM%20IST',
    level: 'Beginner to Advanced',
    duration: '24 weeks',
    description:
      'Go deeper into Apex, integrations, AI, Agentforce and Lightning Web Components to build scalable Salesforce solutions.',
  },
  {
    id: 'full-stack',
    title: 'Full Stack Web Development',
    to: '/course/full-stack-web-development',
    level: 'Beginner to Advanced',
    duration: '24 weeks',
    description:
      'Learn front-end and back-end skills to build production-ready web applications end to end.',
  },
  {
    id: 'web-dev',
    title: 'Web Development',
    to: '/course/web-development',
    level: 'Beginner · Front-end',
    duration: '10 weeks',
    description:
      'Cover modern HTML, CSS, and JavaScript essentials to design and build responsive websites.',
  },
];

const Colleges = () => {
  const { openContactModal } = useContactModal();
  return (
    <>
      <div className="hero-gradient-wrap">
        <Header ctaText="Join Community" ctaPath="#courses" />
        {/* Hero */}
        <section className="colleges-hero">
        <div className="colleges-hero-inner">
          <div className="colleges-hero-left">
            <p className="colleges-hero-kicker">For Colleges</p>
            <h1 className="colleges-hero-title">Grow Industry-Ready Talent on Campus</h1>
            <p className="colleges-hero-text">
              Partner with InfinySkills to embed AI-first, job-ready programs into your curriculum. Blend academic excellence with
              hands-on projects, labs, and industry certifications.
            </p>
            <div className="colleges-hero-actions">
              <button type="button" className="colleges-hero-cta" onClick={openContactModal}>
                Talk to our team
              </button>
              <a href="#courses" className="colleges-hero-secondary">
                View all programs
              </a>
            </div>
            <div className="colleges-hero-stats">
              <div>
                <span className="colleges-hero-stat-number">5000+</span>
                <span className="colleges-hero-stat-label">Students Trained</span>
              </div>
              <div>
                <span className="colleges-hero-stat-number">4.9</span>
                <span className="colleges-hero-stat-label">Rating</span>
              </div>
            </div>
          </div>
          <div className="colleges-hero-right">
            <div className="colleges-hero-image-card">
              <img
                src={collegesHeroImage}
                alt="Students collaborating in a campus setting"
              />
            </div>
          </div>
        </div>
        </section>
      </div>

      <main className="page-layout-main colleges-layout">
      {/* Feature strip */}
      <section className="colleges-feature-strip">
        <div className="colleges-feature">
          <span className="colleges-feature-icon">🎓</span>
          <div>
            <h3>Scholarship Facility</h3>
            <p>Co-create scholarships and outcome-based learning journeys.</p>
          </div>
        </div>
        <div className="colleges-feature">
          <span className="colleges-feature-icon">📚</span>
          <div>
            <h3>Book & Resource Library</h3>
            <p>Curated labs, projects, and content mapped to your syllabus.</p>
          </div>
        </div>
        <div className="colleges-feature">
          <span className="colleges-feature-icon">💻</span>
          <div>
            <h3>Blended Learning</h3>
            <p>On-campus, virtual, and hybrid delivery powered by experts.</p>
          </div>
        </div>
      </section>

      {/* About / intro section */}
      <section className="colleges-about">
        <div className="colleges-about-left">
          <p className="colleges-about-kicker">About Us</p>
          <h2 className="colleges-about-title">Introduction to the Universities Track</h2>
          <p className="colleges-about-text">
            We collaborate with universities and colleges to design industry-backed learning paths in Salesforce, cloud, full-stack
            development, and emerging technologies. Our programs integrate smoothly with academic calendars and accreditation needs.
          </p>
          <ul className="colleges-about-list">
            <li>Curriculum mapped to real job roles and certifications.</li>
            <li>Project-based learning, capstones, and labs.</li>
            <li>Faculty enablement and co-teaching with experts.</li>
            <li>Placement-focused skills in communication and career readiness.</li>
          </ul>
        </div>
        <div className="colleges-about-right">
          <div className="colleges-about-card">
            <p className="colleges-about-stat">16+ Years</p>
            <p className="colleges-about-caption">of combined industry and teaching experience across our core team.</p>
          </div>
          <div className="colleges-about-card colleges-about-card-secondary">
            <p className="colleges-about-caption">
              Trusted by colleges looking to modernize their academic programs with AI-first, cloud-ready skills.
            </p>
          </div>
        </div>
      </section>

      {/* Same course section as B2C – 4 program cards */}
      <section className="b2c-programs" id="courses" aria-labelledby="colleges-programs-title">
        <div className="b2c-programs-inner">
          <header className="b2c-programs-header">
            <p className="b2c-programs-kicker">For Colleges</p>
            <h2 id="colleges-programs-title" className="b2c-programs-title">
              Programs You Can Enroll In
            </h2>
            <p className="b2c-programs-subtitle">
              Pick a focused learning path for your students. Each program blends concepts, labs, and real-world projects aligned to industry needs.
            </p>
          </header>
          <div className="b2c-programs-grid">
            {PROGRAMS.map((program) => (
              <Link key={program.id} to={program.to} className="b2c-program-card">
                <div className="b2c-program-pill" aria-hidden="true" />
                <div className="b2c-program-meta">
                  <span className="b2c-program-level">{program.level}</span>
                  <span className="b2c-program-duration">{program.duration}</span>
                </div>
                <h3 className="b2c-program-title">{program.title}</h3>
                <p className="b2c-program-text">{program.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      </main>
      <Footer />
    </>
  );
};

export default Colleges;
